import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ReschedulePushNotificationUseCaseInterface } from 'domain/usecases';

export class RemoteReschedulePushNotification
  implements ReschedulePushNotificationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: ReschedulePushNotificationUseCaseInterface.Params,
  ): Promise<ReschedulePushNotificationUseCaseInterface.Result> {
    const { id, ...body } = params;
    const httpResponse = await this.httpClient.request({
      url: this.url + `/${id}`,
      body,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
